import n from "react";
import { css as r, cx as e } from "@leafygreen-ui/emotion";
import o from "prop-types";
import t from "@leafygreen-ui/box";
import { Theme as a, isComponentType as i } from "@leafygreen-ui/lib";
import { useDarkMode as l, useUsingKeyboardContext as c } from "@leafygreen-ui/leafygreen-provider";
import { isComponentGlyph as f } from "@leafygreen-ui/icon";
import { validateAriaLabelProps as s } from "@leafygreen-ui/a11y";
import { palette as b } from "@leafygreen-ui/palette";
import { focusRing as g } from "@leafygreen-ui/tokens";

function u(n, r) {
  var e = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), e.push.apply(e, o);
  }

  return e;
}

function d(n) {
  for (var r = 1; r < arguments.length; r++) {
    var e = null != arguments[r] ? arguments[r] : {};
    r % 2 ? u(Object(e), !0).forEach(function (r) {
      p(n, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : u(Object(e)).forEach(function (r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }

  return n;
}

function p(n, r, e) {
  return r in n ? Object.defineProperty(n, r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = e, n;
}

function y() {
  return y = Object.assign || function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
      }
    }

    return n;
  }, y.apply(this, arguments);
}

function h(n, r) {
  if (null == n) return {};

  var e,
      o,
      t = function (n, r) {
    if (null == n) return {};
    var e,
        o,
        t = {},
        a = Object.keys(n);

    for (o = 0; o < a.length; o++) {
      e = a[o], r.indexOf(e) >= 0 || (t[e] = n[e]);
    }

    return t;
  }(n, r);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);

    for (o = 0; o < a.length; o++) {
      e = a[o], r.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(n, e) && (t[e] = n[e]);
    }
  }

  return t;
}

function m(n, r) {
  return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}

var k,
    v,
    O,
    w,
    j,
    x,
    P,
    D,
    L,
    S,
    z,
    E,
    N,
    I,
    C,
    M,
    B,
    X,
    K,
    R = {
  Default: "default",
  Large: "large",
  XLarge: "xlarge"
},
    T = r(k || (k = m(["\n  border: none;\n  -webkit-appearance: unset;\n  padding: unset;\n"]))),
    q = r(v || (v = m(["\n  display: inline-block;\n  border-radius: 100px;\n  position: relative;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: 150ms ease-in-out;\n  transition-property: color, box-shadow;\n\n  // Set background to fully-transparent white for cross-browser compatability with Safari\n  //\n  // Safari treats \"transparent\" values in CSS as transparent black instead of white\n  // which can make things render differently across browsers if not defined explicitly.\n  background-color: rgba(255, 255, 255, 0);\n\n  &:before {\n    content: '';\n    transition: 150ms all ease-in-out;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 100%;\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  &:active:before,\n  &:hover:before,\n  &:focus:before {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]))),
    A = (p(x = {}, R.Default, r(O || (O = m(["\n    height: 28px;\n    width: 28px;\n  "])))), p(x, R.Large, r(w || (w = m(["\n    height: 36px;\n    width: 36px;\n  "])))), p(x, R.XLarge, r(j || (j = m(["\n    height: 42px;\n    width: 42px;\n  "])))), x),
    F = (p(L = {}, a.Light, r(P || (P = m(["\n    color: ", ";\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), b.gray.base, b.black, b.gray.light2)), p(L, a.Dark, r(D || (D = m(["\n    color: ", ";\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), b.gray.light1, b.gray.light3, b.gray.dark1)), L),
    G = (p(E = {}, a.Light, r(S || (S = m(["\n    &:focus {\n      color: ", ";\n      box-shadow: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), b.black, g[a.Light].default, b.gray.light2)), p(E, a.Dark, r(z || (z = m(["\n    &:focus {\n      color: ", ";\n      box-shadow: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), b.gray.light3, g[a.Dark].default, b.gray.dark1)), E),
    H = (p(C = {}, a.Light, r(N || (N = m(["\n    cursor: not-allowed;\n    color: ", ";\n    background-color: rgba(255, 255, 255, 0);\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: rgba(255, 255, 255, 0);\n      }\n    }\n\n    &:focus {\n      color: ", ";\n\n      &:before {\n        background-color: rgba(255, 255, 255, 0);\n      }\n    }\n  "])), b.gray.light1, b.gray.light1, b.gray.light1)), p(C, a.Dark, r(I || (I = m(["\n    cursor: not-allowed;\n    color: ", ";\n    background-color: rgba(255, 255, 255, 0);\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: rgba(255, 255, 255, 0);\n      }\n    }\n\n    &:focus {\n      color: ", ";\n\n      &:before {\n        background-color: rgba(255, 255, 255, 0);\n      }\n    }\n  "])), b.gray.dark1, b.gray.dark1, b.gray.dark1)), C),
    J = (p(X = {}, a.Light, r(M || (M = m(["\n    color: ", ";\n\n    &:before {\n      background-color: ", ";\n      opacity: 1;\n      transform: scale(1);\n    }\n  "])), b.black, b.gray.light2)), p(X, a.Dark, r(B || (B = m(["\n    color: ", ";\n\n    &:before {\n      background-color: ", ";\n      opacity: 1;\n      transform: scale(1);\n    }\n  "])), b.gray.light3, b.gray.dark1)), X),
    Q = r(K || (K = m(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))),
    U = ["size", "darkMode", "disabled", "active", "className", "children"],
    V = n.forwardRef(function (r, o) {
  var a,
      b,
      g = r.size,
      u = void 0 === g ? R.Default : g,
      m = r.darkMode,
      k = r.disabled,
      v = void 0 !== k && k,
      O = r.active,
      w = void 0 !== O && O,
      j = r.className,
      x = r.children,
      P = h(r, U),
      D = l(m).theme,
      L = c().usingKeyboard,
      S = "string" == typeof P.href;
  s(P, "IconButton");
  var z = n.Children.map(x, function (r) {
    if (!r) return null;

    if (i(r, "Icon") || f(r)) {
      var e = r.props,
          o = e.size,
          t = e.title,
          a = {
        size: o || u
      };
      return "string" == typeof t && 0 !== t.length || (a.title = !1), n.cloneElement(r, a);
    }

    return r;
  }),
      E = d(d({}, P), {}, (p(b = {
    ref: o,
    tabIndex: 0
  }, "aria-disabled", v), p(b, "href", v ? void 0 : P.href), p(b, "onClick", v ? void 0 : P.onClick), p(b, "className", e(T, q, A[u], F[D], (p(a = {}, G[D], L), p(a, J[D], w && !v), p(a, H[D], v), a), j)), b));
  return n.createElement(t, y({
    as: S ? "a" : "button"
  }, E), n.createElement("div", {
    className: Q
  }, z));
});
V.displayName = "IconButton", V.propTypes = {
  darkMode: o.bool,
  size: o.oneOf(Object.values(R)),
  className: o.string,
  children: o.node,
  disabled: o.bool,
  href: o.string,
  active: o.bool
};
export { R as Size, V as default };